import toast from "react-hot-toast";
import { ReactComponent as Apple } from "../../../assets/download-apple.svg";

export default function BackupKey({ data }) {
  return (
    <div className="row row-sm">
      <div className="css-weqpav mt-2">
        <div className="css-1xfmg0p">
          <Apple style={{ height: "96px", width: "96px" }} className="apple-icon" />
        </div>
        <div className="css-wiulhc"></div>
        <div className="css-1t5xnih">
          <div className="css-vurnku">
            Resetting your Google Authentication requires opening a support
            ticket and takes at least 7 days to process.
          </div>
          <div className="css-1gv6rnn">
            <div className="css-ryy4eq" onClick={() => {
              navigator.clipboard
              .writeText(data.backup_key)
              .then(() => {
                toast.success("Copied to clipboard");
              })
              .catch((error) => {
                console.log(error);
              });
            }}>{data.google2fa_code}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
